import React from 'react';
import './Navbar.css';
import R from 'ramda';
import _debounce from 'lodash/debounce'
import NavbarMainItem from './NavbarMainItem';
import classNames from 'classnames';
import { navbarData } from '../data';
import {jumpToSection} from '../resources/utils/utilities';

export function toggleIsStickyNav(bool) {
  return function update(state) {
    return { isStickyNav: bool }
  }
}

export function toggleMobileNavigationMenuOpen(state) {
  return { mobileNavOpen: !state.mobileNavOpen }
}

class Navbar extends React.Component {
  constructor() {
    super();
    this.state = {
      isStickyNav: false,
      mobileNavOpen: false
    }
    this.stickyNavOnScrollHandler = this.stickyNavOnScrollHandler.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', _debounce(this.stickyNavOnScrollHandler, 100));
    if(window.location.hash) {
      jumpToSection(window.location.hash);
    } else {
      jumpToSection('#home');
    }
    this._isMounted = true;
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', _debounce(this.stickyNavOnScrollHandler, 100));
    this._isMounted = false;
  }

  stickyNavOnScrollHandler() {
    if(!this._isMounted) {return;}
    const mainPageTop = document.querySelector('#top');
    if (mainPageTop) {
      const scrollPosition = window.pageYOffset;
      const topSectionHeight = mainPageTop.clientHeight;
      const halfTopSectionHeight = topSectionHeight / 2;
      const currentStickyState = this.state.isStickyNav;
      if (scrollPosition > halfTopSectionHeight) {
        if (!currentStickyState) {this.handleToggleStickyNav(true)};
      } else {
        if (currentStickyState) {this.handleToggleStickyNav(false)};
      }
    }
  }

  handleToggleStickyNav(bool) {
    this.setState(toggleIsStickyNav(bool));
  }

  handleToggleMobileNavigationMenu = () => {
    this.setState(toggleMobileNavigationMenuOpen);
  }

  render() {
    const flexNavClasses = classNames('flex-nav',
      {'sticky-nav': R.prop('isStickyNav', this.state),
      'drop-down-nav': R.prop('mobileNavOpen', this.state)
    }
    );
    const mobileNavIconClasses = classNames(
      'mobile-nav-icon',
      {'ion-close-round': R.prop('mobileNavOpen', this.state),
      'ion-navicon-round': R.not(R.prop('mobileNavOpen', this.state))
      }
    );
    const outerUlClasses = classNames(
      'outer-ul',
      {'open': R.prop('mobileNavOpen', this.state)}
    )

    return (
      <nav className={flexNavClasses}>
        <div className='row'>
          <a className="toggleNav mobile-nav-icon-link" onClick={() => this.handleToggleMobileNavigationMenu()}><i className={mobileNavIconClasses}></i></a>
          <ul className={outerUlClasses}>
            { navbarData.map((navItem, index) =>
              <NavbarMainItem
                navItem={navItem}
                key={index}
                mobileNavOpen={this.state.mobileNavOpen}
                handleToggleMobileNavigationMenu={this.handleToggleMobileNavigationMenu}
              >
              </NavbarMainItem>) }
          </ul>
        </div>
      </nav>
    )
  }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar.js